// src/components/ProtectedRoute/Admin/Consoles/Pages/PublicationsConsole.jsx
import React from "react";
import ConsolePageFrame from "../Framework/ConsolePageFrame";
import publicationsPlugin from "./publications.plugin";
import DialogPublicationUpsert from "./DialogPublicationUpsert";

export default function PublicationsConsole() {
  return (
    <ConsolePageFrame
      title="Publications"
      plugin={publicationsPlugin}
      searchPlaceholder="Search title / ID / DOI / Authors / Journal"
      searchFieldProps={{ sx: { minWidth: 360 } }}
      columnsBuilder={({ onEdit }) => publicationsPlugin.columns({ onEdit })}
      renderAddDialog={({ onClose }) => (
        <DialogPublicationUpsert open mode="add" onClose={onClose} />
      )}
      renderEditDialog={({ row, onClose }) => (
        <DialogPublicationUpsert open mode="edit" publication={row} onClose={onClose} />
      )}
      toastMessages={{ create: "Publication created", update: "Publication updated" }}
    />
  );
}
